import React from 'react';
import WaypointsWrapper from '../../../../components/Waypoints/WaypointsWrapper';
import { DescriptionSection } from './description_section';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

// TODO: Replace this with the MapCreator forms and no longer use tabs so design is in-sync
const TrackOverview = createReactClass({
  getInitialState() {
    return {
      activeTab: this.getInitialTab(),
      isMobileWidth: false
    };
  },
  getInitialTab() {
    let activeTab = null;
    if (this.props.data.description) activeTab = 'Description';
    else if (this.props.data.waypoints && this.props.data.waypoints.length > 0) activeTab = 'Waypoints';
    else activeTab = 'Description';
    // Otherwise we're going to hide this section
    return activeTab;
  },
  isMobileWidth() {
    return typeof window != 'undefined' && window.innerWidth <= 767;
  },
  componentWillMount() {
    let { activeTab } = this.state;
    const isMobileWidth = this.isMobileWidth();
    if (activeTab == null && isMobileWidth) activeTab = 'Description';
    this.setState({ isMobileWidth, activeTab });
  },
  componentDidMount() {
    if (!this.state.isMobileWidth && this.state.activeTab == null) $('#overview-content').hide();
    window.addEventListener('resize', this.handleResize);
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  handleResize() {
    let { activeTab } = this.state;
    const isMobileWidth = this.isMobileWidth();
    if (activeTab == null && isMobileWidth) {
      $('#overview-content').show();
      activeTab = 'Description';
    }
    if (!isMobileWidth && activeTab === 'Description') {
      activeTab = this.getInitialTab();
    }
    if (activeTab == null) $('#overview-content').hide();
    this.setState({ isMobileWidth, activeTab });
  },

  // Code extracted from TabMixin
  handleHover(tabName) {
    const arrow = $(this.refs.arrow);
    const currTabNode = $(this.refs[tabName]);
    const leftPos = currTabNode.position().left + currTabNode.width() / 2;
    arrow.stop(true, true).animate({ left: leftPos }, 500);
    return false;
  },
  handleClick(tabName, gaqList) {
    if (gaqList && gaqList.length == 3) {
      _gaq.push('_trackEvent', gaqList[0], gaqList[1], gaqList[2]);
    }
    this.setState({ activeTab: tabName });
    return false;
  },
  handleMouseOut() {
    const currTabNode = $(this.refs[this.state.activeTab]);
    const arrow = $(this.refs.arrow);
    const leftPos = currTabNode.position().left + currTabNode.width() / 2;
    arrow.stop(true, true).animate({ left: leftPos }, 500);
    return false;
  },
  getNewTabDivs(tabNames, tabCounts, gaqArray) {
    return tabNames.map(
      function(tab, index) {
        let classes = 'pull-left ';
        // attempt to lookup translated titles here
        let tabTitle = StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.TAB_NAMES, tab);
        if (tabCounts && tabCounts.length > index) {
          tabTitle = `${tabTitle} (${tabCounts[index].toLocaleString()})`;
        }
        if (this.state.activeTab == tab) {
          classes += 'active';
        }
        let clickHandler = this.handleClick.bind(null, tab);
        if (gaqArray && gaqArray[index]) {
          clickHandler = this.handleClick.bind(null, tab, gaqArray[index]);
        }
        return (
          <div className={classes} key={index} ref={tab} onClick={clickHandler}>
            <h3 onMouseEnter={this.handleHover.bind(null, tab)}>
              <a name={tab}>{tabTitle}</a>
            </h3>
          </div>
        );
      }.bind(this)
    );
  },

  render() {
    if (!this.state.activeTab) return null;
    const availableTabNames = [];
    if (this.props.canEdit || this.props.data.description) {
      availableTabNames.push('Description');
    }
    if (this.props.canEdit || (this.props.data.waypoints && this.props.data.waypoints.length)) {
      availableTabNames.push('Waypoints');
    }
    if (!availableTabNames.length) {
      return null;
    }
    let activeContent;
    switch (this.state.activeTab) {
      case 'Description':
        activeContent = (
          <DescriptionSection
            canEdit={this.props.canEdit}
            data={this.props.data.description}
            dataSource={this.props.data.description_source}
            handleSubmit={this.props.handleDescriptionSubmit}
            handleSubmitSuccess={this.props.handleMapInfoChanged}
            messagingChannel={this.props.messagingChannel}
            placeholderText={StringConstantsMixin.strings.TRACK_DETAIL.TELL_WHAT_YOU_DID}
            ref="mapDescription"
            showHeader={false}
          />
        );
        break;
      case 'Waypoints':
        activeContent = (
          <WaypointsWrapper
            canEdit={this.props.canEdit}
            waypoints={this.props.data.waypoints}
            mapId={this.props.result.ID}
            messagingChannel={this.props.messagingChannel}
            isAdmin={this.props.currentUser && this.props.currentUser.admin}
          />
        );
        break;
    }
    return (
      <div>
        <div className="content-menu" onMouseLeave={this.handleMouseOut}>
          {this.getNewTabDivs(availableTabNames)}
        </div>
        <div className="tab-container">{activeContent}</div>
      </div>
    );
  }
});

export { TrackOverview };
